import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '@env/environment';
import { ActiveSession } from '@app/utils/interfaces/active-session.interface';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';

@Injectable({
  providedIn: 'root',
})
export class ActiveSessionsService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly httpClient = inject(HttpClient);

  public getSessions(): Observable<ActiveSession[]> {
    return this.httpClient
      .get<{ data: ActiveSession[] }>(this.baseUrl + ApiEndpoints.GET_ACTIVE_SESSIONS)
      .pipe(map(({ data }: { data: ActiveSession[] }) => data));
  }

  public terminateSession(id: string): Observable<HttpResponse<void>> {
    return this.terminate(ApiEndpoints.DELETE_SESSION + id);
  }

  public terminateAllSessions(): Observable<HttpResponse<void>> {
    return this.terminate(ApiEndpoints.DELETE_ALL_SESSIONS);
  }

  private terminate(path: string): Observable<HttpResponse<void>> {
    return this.httpClient.delete<void>(this.baseUrl + path, { observe: 'response' });
  }
}
